// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".assessment-details-view__actions{display:flex;justify-content:flex-end}", ""]);
// Exports
module.exports = exports;
